import { useMutation } from '@tanstack/react-query';
import { OrganizationDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export type UpdateOrganizationCampaignFrequencyCapDto = {
    campaignFrequencyCapPerWeek: number;
};

export const useUpdateCampaignFrequencyCap = (organizationId: string) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateCampaignFrequencyCap', organizationId],
        mutationFn: (body: UpdateOrganizationCampaignFrequencyCapDto) =>
            apiClient.fetchApi<OrganizationDto, UpdateOrganizationCampaignFrequencyCapDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/campaign-frequency-cap`,
                body,
            }),
        onSuccess: (data) => {
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};
